import { render, staticRenderFns } from "./ModuleCheckboxes.vue?vue&type=template&id=40e1b248&scoped=true"
import script from "./ModuleCheckboxes.vue?vue&type=script&lang=ts"
export * from "./ModuleCheckboxes.vue?vue&type=script&lang=ts"
import style0 from "./ModuleCheckboxes.vue?vue&type=style&index=0&id=40e1b248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e1b248",
  null
  
)

export default component.exports